export default __webpack_public_path__ + "static/media/attachment.469108e2.svg";